<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements";
  import Link from "./Link.svelte";
  import CrossCircle from "../icons/CrossCircle.svelte";
  import { slide } from "svelte/transition";
  import { cubicOut } from "svelte/easing";

  interface Props extends HTMLAttributes<HTMLDivElement> {
    type?: "text" | "area";
    error?: string;
    link?: { text: string; href: string };
  }

  let { type = "text", error, link, class: className, ...rest }: Props = $props();
</script>

{#if type === "text"}
  <div
    {...rest}
    class={["flex w-full items-center gap-3 text-sm text-sec-900", className]}
    transition:slide={{ duration: 200, easing: cubicOut }}
  >
    <CrossCircle aria-hidden="true" size={16} />
    {error}
    {#if link}
      <span class="text-sec-800"> - </span>
      <Link variant="secondary" color="sec-800" size="sm" href={link.href} text={link.text} />
    {/if}
  </div>
{:else}
  <div
    {...rest}
    class={[
      "flex w-full items-center justify-center gap-3 rounded-lg border border-sec-800/10 bg-sec-800/5 px-3 py-1.5 text-sm text-sec-800",
      className,
    ]}
    transition:slide={{ duration: 200, easing: cubicOut }}
  >
    <span class="hidden sm:block"><CrossCircle size={16} /></span>
    {error}
  </div>
{/if}
